import { Component, Inject, OnInit, HostListener } from '@angular/core';
import { ModalService } from '@edassist/shared';
import { MODAL_SIZES, ModalComponent } from '@edassist-ui/modal';
import { BUTTON_TYPES } from '@edassist-ui/button';
import { BUTTON_CONTAINER_ALIGNMENT, BUTTON_CONTAINER_JUSTIFICATION } from '@edassist-ui/button-container';
import { constants, WINDOW, GoogleTagManagerEventService } from '@edassist/common';

@Component({
	selector: 'ea-external-navigation-modal',
	templateUrl: './external-navigation-modal.component.html',
	styleUrls: ['./external-navigation-modal.component.scss']
})
export class ExternalNavigationModalComponent implements OnInit {
	modalComponent = ModalComponent;
	BUTTON_CONTAINER_ALIGNMENT = BUTTON_CONTAINER_ALIGNMENT;
	BUTTON_CONTAINER_JUSTIFICATION = BUTTON_CONTAINER_JUSTIFICATION;
	BUTTON_TYPES = BUTTON_TYPES;
	MODAL_SIZES = MODAL_SIZES;
	constants = constants;
	externalModalId: string;
	externalUrl: string;
	externalLinkTitle: string;
	isExternalLinkClick: boolean;

	constructor(
		@Inject(WINDOW) private readonly window: Window,
		private readonly modalService: ModalService,
		private readonly gtmEventService: GoogleTagManagerEventService
	) {}

	@HostListener('document:click', ['$event'])
	onClick(event: MouseEvent): void {
		const element = event.target as HTMLElement;
		this.externalLinkTitle =
			element.parentElement?.getAttribute('data-link-title') ||
			(element.textContent.length > 0 ? element.textContent : element.getAttribute('alt'));
		this.externalUrl = element.getAttribute('href') || element.parentElement.getAttribute('href') || this.externalUrl;
		if (element.tagName === 'A' || element.parentNode.nodeName === 'A') {
			let linkDomain;
			let windowDomain;
			if (this.isValidHref(this.externalUrl)) {
				const anchorHostName = new URL(this.externalUrl);
				linkDomain = this.getDomain(anchorHostName.hostname);
				windowDomain = this.getDomain(window.location.hostname);
				if (linkDomain !== windowDomain) {
					this.checkExternalLink(anchorHostName, linkDomain, event);
				}
			}
		}
	}

	ngOnInit(): void {
		this.externalModalId = constants.modalIds.EXTERNAL_NAVIGATION;
	}

	getDomain(hostName): string {
		const splitHostName = hostName.split('.').reverse();

		return `${splitHostName[1]}.${splitHostName[0]}`;
	}

	isValidHref(element): boolean {
		return /^http(s?):\/\//.test(element);
	}

	checkExternalLink(href, linkDomain, event): void {
		this.isExternalLinkClick = !constants.externalLinks.whiteListedDomains.includes(linkDomain);
		if (this.isExternalLinkClick) {
			event.preventDefault();
			this.modalService.openModal(this.externalModalId);
		}
	}

	openModalAndSetExternalUrl(url: string): void {
		this.externalUrl = url;
		this.modalService.openModal(this.externalModalId);
	}

	closeModal(): void {
		this.modalService.closeModal(this.externalModalId);
	}
	sendGA4Events(): void {
		// GA4 for OutBoundLink event
		this.gtmEventService.sendOutboundLinkClick(
			this.externalLinkTitle,
			this.externalUrl,
			constants.googleAnalytics.callToAction.pageSection.body
		);
		// Send cta_click event to GTM
		this.gtmEventService.sendCtaClick(
			'Continue',
			this.externalUrl,
			constants.googleAnalytics.callToAction.pageSection.body
		);
		// GA4 for content interact
		let contentLinkType = this.externalUrl.indexOf('video') > 0 ? 'video link ' : `${this.externalLinkTitle}link`;
		// GA4 for content interact event
		this.gtmEventService.sendContentInteract(this.externalLinkTitle, '', contentLinkType, this.externalLinkTitle);
	}

	navigateToExternalUrl(): void {
		this.sendGA4Events();
		this.modalService.closeModal(this.externalModalId);
		window.open(this.externalUrl);
	}
}
